import { useEffect, useState } from 'react';

import { getRemainingTime } from '@src/helpers';

import AnimatedBox from './AnimatedBox';
import WebinarLobbyBackground from './WebinarLobbyBackground';

import styles from './WebinarLobbyBackground.module.scss';
import useSendPageFinished from '@src/hooks/useSendPageFinished';

interface WebinarCountDownProps {
  targetTime: Date | string | number;
  webinarTitle: string;
  onComplete?: () => void;
}

const WebinarCountDown: React.FC<WebinarCountDownProps> = ({ targetTime, webinarTitle, onComplete }) => {
  const [remainingTime, setRemainingTime] = useState(getRemainingTime(new Date(targetTime)));

  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingTime(getRemainingTime(new Date(targetTime)));
    }, 1000);

    return () => clearInterval(interval);
  }, [targetTime]);

  useEffect(() => {
    if (remainingTime.ended) {
      if (onComplete) onComplete();
    }
  }, [onComplete, remainingTime.ended]);

  useSendPageFinished({ isMeetingEnded: false });

  return (
    <div className={styles.webinarLobbyContainer}>
      <WebinarLobbyBackground>
        <div className={styles.countdownWrapper}>
          <div className={styles.countdownContent}>
            <h2 className={styles.countdownTitle}>{webinarTitle} webinar starts in</h2>
            <div className={styles.countdownTimer}>
              <AnimatedBox value={remainingTime.days} label="Day" />
              <AnimatedBox value={remainingTime.hours} label="Hour" />
              <AnimatedBox value={remainingTime.minutes} label="Minute" />
              <AnimatedBox value={remainingTime.seconds} label="Second" />
            </div>
          </div>
          <p className={styles.countdownFooter}>
            Boost your connections and enhance your productivity with v tools{' '}
            <a href="" className={styles.productsLink}>
              here
            </a>
            .
          </p>
        </div>
      </WebinarLobbyBackground>
    </div>
  );
};

export default WebinarCountDown;
